module.exports = "/images/fondo-01.jpg?71a79e0725d2802ca84537c9710eafeb";


//////////////////
// WEBPACK FOOTER
// ./resources/images/assets2020/fondo-01.jpg
// module id = 8s5N
// module chunks = 0